<template>
	<div class="home">
		<div class="wrapper">
			<img class="phone" src="../assets/shot.jpg" />
			<div class="content">
				<img class="logo" src="../assets/logo.png" />
				<p class="logo-name">专注ing</p>
				<a class="btn ios" :href="idownload">iOS下载</a>
				<a class="btn android" @click="chooseCh">安卓下载</a>
			</div>
			<div class="contact">
				<span>联系邮箱：kefu@quthing.com</span>
				<span
					>©️2019 北京夕航科技有限公司 版权所有 | 京ICP备18026356号-1
					|</span
				>
			</div>
		</div>
		<div class="m-wrapper">
			<div id="tip" v-show="tipShow">请点击右上角“…”，在浏览器中打开</div>
			<div class="wrapper2">
				<img class="logo2" src="../assets/logo.png" />
				<p class="logo-name2">专注ing</p>
				<a class="btns" @click="goDownload">立即下载</a>
				<div class="contact2">
					<span>联系邮箱：kefu@quthing.com</span>
					<div>
						©️2019 北京夕航科技有限公司 版权所有 |
						京ICP备18026356号-1 |
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "home",
		data() {
			return {
				tipShow: false,
				idownload: process.env.VUE_APP_IDOWNLOAD
			};
		},
		beforeMount() {},
		methods: {
			goDownload() {
				var u = navigator.userAgent,
					app = navigator.appVersion;
				var isAndroid =
					u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
				let isPad = u.indexOf("iPad") > -1 || u.indexOf("Mac OS X") > -1;
				var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) || isPad; //ios终端
				var isWeixinBrowser = /micromessenger/i.test(navigator.userAgent); //微信浏览器
				if (isIOS && !isAndroid) {
					window.location.href = process.env.VUE_APP_IDOWNLOAD;
				} else if (isAndroid && !isIOS) {
					if (isWeixinBrowser) {
						this.tipShow = true;
					} else {
						window.location.href = process.env.VUE_APP_ADOWNLOAD;
					}
				}
			},
			chooseCh() {
				window.location.href = process.env.VUE_APP_ADOWNLOAD;
			}
		}
	};
</script>
<style type="text/css" scoped>
	.home {
		width: 100%;
		height: 100%;
	}

	.wrapper {
		width: 100%;
		height: 100%;
		/*max-width: 100%;*/
		min-width: 980px;
		background-image: linear-gradient(to bottom right, #f0fbf3, #cff2db);
		background-size: 100% 100%;
	}

	.btn {
		display: inline-block;
		text-decoration: none;
		width: 250px;
		height: 65px;
		font-size: 28px;
		text-align: center;
		line-height: 65px;
		border-radius: 8px;
		color: #fff;
		margin: 50px 10px;
	}

	.ios {
		background: #38b799;
		background-size: 100% 100%;
		/* margin-left: 370px; */
		margin-top: 50px;
	}

	.android {
		background: #38b799;
		background-size: 100% 100%;
		/* margin-top: 10px; */
		/* margin-left: 370px; */
	}

	.phone {
		/* width: 408px; */
	    height: 80%;
   		right: 6.66667rem;
		position: absolute;
		bottom: 0;
	}

	.logo {
		width: 157px;
		height: 173px;
		margin: 0 auto;
		padding-bottom: 10px;
	}
	.logo-name {
		font-size: 22px;
	}
	.logo2 {
		width: 120px;
		padding-bottom: 10px;
	}
	.logo-name2 {
		font-size: 18px;
		padding-bottom: 40px;
	}

	.content {
		position: absolute;
		bottom: 200px;
		left: 250px;
		text-align: center;
	}

	.logo {
		display: block;
		/* margin-left: 450px; */
	}

	.contact {
		font-size: 16px;
		color: #9d9ca6;
		position: absolute;
		bottom: 20px;
		left: 100px;
	}

	.contact2 {
		font-size: 16px;
		color: #9d9ca6;
		position: absolute;
		bottom: 20px;
		left: 0;
		right: 0;
		text-align: center;
	}

	.contact span:nth-child(2) {
		margin-left: 46px;
	}

	.contact span:nth-child(3) {
		margin-left: 46px;
	}

	.wrapper2 {
		width: 100%;
		height: 100%;
		background-image: linear-gradient(to bottom right, #f0fbf3, #cff2db);
		background-size: 100% 100%;
		padding-top: 120px;
		box-sizing: border-box;
		text-align: center;
	}

	.btns {
		display: block;
		background: #38b799;
		box-shadow: 0 0.16rem 0.32rem 0 rgba(255, 84, 134, 0.24);
		border-radius: 1.333333rem;
		text-align: center;
		width: 5.84rem;
		height: 1.386667rem;
		line-height: 1.4rem;
		color: #fff;
		font-size: 0.48rem;
		margin: 0 auto;
		text-decoration: none;
	}

	.btns:hover {
		opacity: 0.64;
		text-decoration: none;
	}

	#tip {
		width: 100%;
		height: 1.066667rem;
		line-height: 1.1rem;
		color: #fff;
		background: rgba(24, 22, 42, 0.7);
		font-size: 0.426667rem;
		text-align: center;
	}

	.right {
		display: inline-block;
		width: 0.426667rem;
		height: 0.426667rem;
		background: url(https://static.xixitime.com/coupleDownPage/images/right.png);
		background-size: 100% 100%;
	}

	.m-wrapper {
		width: 100%;
		height: 100%;
		display: none;
	}

	@media all and (max-width: 768px) {
		.m-wrapper {
			display: block;
		}

		.wrapper {
			display: none;
		}
	}
</style>
